"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
/** Set Scene layout real time action */
function setSceneLayoutRealtime(sceneLayout) {
  return (0, _utils.actionCreator)(_types.BROADCAST_SET_SCENE_LAYOUT_REAL_TIME, sceneLayout);
}
var _default = exports["default"] = setSceneLayoutRealtime;